import api from '../api';
/**
 * Upload a file to the manager API
 * @param {File} file - The file to upload
 * @param {string} [url='/upload'] - Relative upload URL (uses api baseURL)
 * @returns {Promise<{ name: string, type: string, size: string }>} The upload response
 * @throws {Error} On 400 with response body { message }, or other API errors
 */
export const uploadFile = async (file, url = '/upload') => {
  // await new Promise((resolve) => { setTimeout(resolve, 400); });
  // const mockUploadSuccessResponse = {
  //   name: file.name,
  //   type: file.type || 'application/octet-stream',
  //   size: String(file.size),
  // };
  // return mockUploadSuccessResponse(file);

  const formData = new FormData();
  formData.append('file', file);

  try {
    const response = await api.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    if (error?.response?.status === 400 && error?.response?.data?.message) {
      throw new Error(error.response.data.message);
    }
    throw error;
  }
};
